import React, { useState } from "react";
import {
  signInWithPopup,
  GoogleAuthProvider,
  sendSignInLinkToEmail // Import function for magic link (example)
} from "firebase/auth";
import { auth } from "../firebase"; // Adjust path if necessary
import './SignInModal.css'; // Import the specific modal styles

// Simple inline SVG for Google icon (same as before)
const GoogleIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px', verticalAlign: 'middle' }}>
      <path d="M17.64 9.20455C17.64 8.56636 17.5827 7.95273 17.4764 7.36364H9V10.845H13.8436C13.635 11.97 13.0009 12.9232 12.0477 13.5614V15.8195H14.9564C16.6582 14.2527 17.64 11.9455 17.64 9.20455Z" fill="#4285F4"/>
      <path d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5614C11.2418 14.1014 10.2109 14.4205 9 14.4205C6.65591 14.4205 4.67182 12.8377 3.96409 10.71H0.957275V13.0418C2.43818 15.9832 5.48182 18 9 18Z" fill="#34A853"/>
      <path d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29H0.957275C0.347727 8.51727 0 10.1727 0 11.9182C0 13.6636 0.347727 15.3182 0.957275 16.5455L3.96409 13.8818V10.71Z" fill="#FBBC05"/>
      <path d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34545C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16227 6.65591 3.57955 9 3.57955Z" fill="#EA4335"/>
    </svg>
  );

function SignInModal({ onClose }) {
  const [email, setEmail] = useState("");
  // Removed password, isSignUp, and error states
  const [isSendingLink, setIsSendingLink] = useState(false); // Optional: feedback for magic link

  // Initialize Google provider
  const googleProvider = new GoogleAuthProvider();
  googleProvider.setCustomParameters({
    prompt: 'select_account'
  });

  // Prevent modal close on content click
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  // Handle Email Sign In (Example: Using Magic Link)
  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    setIsSendingLink(true); // Indicate process started

    // ** Magic Link Implementation Example **
    const actionCodeSettings = {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be whitelisted in the Firebase Console.
      url: window.location.origin, // Use current origin or specific landing page
      // This must be true.
      handleCodeInApp: true,
    };

    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem('emailForSignIn', email);
      alert(`A sign-in link has been sent to ${email}. Please check your inbox.`);
      setIsSendingLink(false);
      onClose(); // Close modal after sending link
    } catch (err) {
      console.error("Error sending sign-in link:", err);
      // Handle errors (e.g., invalid email)
      alert(`Could not send sign-in link: ${err.message}`);
      setIsSendingLink(false);
    }

    // ** Alternative: Simple Placeholder Logic **
    // console.log("Initiating email sign in for:", email);
    // alert("Email sign-in process initiated (implement actual logic like magic link). Check console.");
    // onClose(); // Close modal immediately if just logging
  };

  // Handle Google Sign-In
  const handleGoogleSignIn = async () => {
    try {
      // Add additional scopes if needed
      googleProvider.addScope('email');
      googleProvider.addScope('profile');
      
      const result = await signInWithPopup(auth, googleProvider);
      console.log("Google sign-in successful:", result);
      onClose(); // Close modal on success
    } catch (err) {
      console.error("Error with Google Sign-In:", err);
      if (err.code === 'auth/popup-closed-by-user') {
        // User closed the popup, no need to show error
        return;
      }
      if (err.code === 'auth/popup-blocked') {
        alert("Please allow pop-ups for this site to sign in with Google.");
        return;
      }
      if (err.code === 'auth/network-request-failed') {
        alert("Network error. Please check your internet connection and try again.");
        return;
      }
      // For other errors, show a more specific message
      alert(`Could not sign in with Google: ${err.message}`);
    }
  };

  return (
    <div className="signin-modal-overlay" onClick={onClose}>
      <div className="signin-modal-content" onClick={handleModalContentClick}>

        {/* Google Sign In Button */}
        <button className="signin-google-btn" onClick={handleGoogleSignIn}>
          <GoogleIcon /> Sign in with Google
        </button>

        {/* Separator */}
        <div className="signin-separator">
          <span>- or -</span>
        </div>

        {/* Email Form */}
        <form className="signin-email-form" onSubmit={handleEmailSignIn}>
          <label htmlFor="signin-email-input">Email</label>
          <input
            id="signin-email-input"
            type="email"
            placeholder="email@example.com"
            className="signin-email-input" // Use correct class
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-label="Email"
          />
          {/* Removed Password Input */}
          {/* Removed Error Display */}

          <button type="submit" className="signin-email-btn" disabled={isSendingLink}>
            {isSendingLink ? "Sending Link..." : "Sign in with Email"}
          </button>
        </form>

        {/* Removed Toggle Button */}

        {/* Free Text */}
        <p className="signin-free-text">Startup intel for smart switches</p>

        {/* Terms Text */}
        <p className="signin-terms-text">
          By using SwitchSmartly.com you agree to our{' '}
          <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a>
        </p>

      </div>
    </div>
  );
}

export default SignInModal;